import React from "react";
import { NotFound } from "../../components/common/NotFound.tsx";

export function NotFoundPage() {
  return <NotFound name="Page" />;
}
